import React from 'react';
import PropTypes from 'prop-types';
import Tile from '../Tile';
import cn from 'classnames';

import styles from './product-tile.module.css';

const ProductTile = ({ children, ...tileProps }) => (
  <div className={styles.productTile}>
    <Tile {...tileProps}>
      {({ Input, inputProps, Label, labelProps, productName, imageSlot, isHorizontal }) => (
        <>
          {Label &&
            <div className={styles.productInformation}>
              <Label
                {...labelProps}
                id={`${labelProps.name}-label`}
                marginBottom={0}
              >
                {productName}
              </Label>
              {Input &&
                <span className={styles.input}>
                  <Input
                    {...inputProps}
                    aria-describedby={`${labelProps.name}-content`}
                    aria-labelledby={`${labelProps.name}-label`}
                  />
                </span>
              }
            </div>
          }
          <div className={styles.contentBox}>
            {imageSlot &&
              <div
                className={cn(styles.imageCell, {
                  [styles.imageCellHorizontal]: isHorizontal,
                  [styles.imageCellVertical]: !isHorizontal,
                })}
              >
                {imageSlot}
              </div>
            }
            <div className={styles.children} id={`${labelProps.name}-content`}>
              {children}
            </div>
          </div>
        </>
      )}
    </Tile>
  </div>
);

ProductTile.displayName = 'ProductTile';

ProductTile.propTypes = {
  imageSlot: PropTypes.node,
  isHorizontal: PropTypes.bool,
  productName: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default ProductTile;
